import React, { Fragment, FunctionComponent } from "react";
import RootPageProps from "./RootPageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const RootPage: FunctionComponent<RootPageProps> = (props): JSX.Element => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return <ContentPageBlock key={index} {...blockContent} />;
            })}
        </Fragment>
    );
};

export default RootPage;